import type { InputHTMLAttributes, ReactNode } from "react";
import { cn } from "../lib/cn";

type CheckboxFieldProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type"> & {
  label: ReactNode;
};

export function CheckboxField({ className, id, label, required, ...props }: CheckboxFieldProps) {
  return (
    <label className={cn("cf-checkbox-field", className)} htmlFor={id}>
      <input id={id} className="cf-checkbox-input" type="checkbox" required={required} {...props} />
      <span>
        {label}
        {required ? (
          <span className="cf-required" aria-hidden="true">
            {" "}
            *
          </span>
        ) : null}
      </span>
    </label>
  );
}
